import React from 'react';
import { useTranslation } from 'react-i18next';
import { PiCurrencyDollarLight } from 'react-icons/pi';
import GlassCard from '../../shared/brand/GlassCard';
import UserBillingRatePanel from '../../Settings/economics/UserBillingRatePanel';

/**
 * This person's billing rates, in the same glass pane as everything else on
 * the page. The editor itself is the shared economics panel - rates are one
 * thing everywhere, and administration only decides who may edit them.
 */
const UserRatesPanel: React.FC<{ userId: number }> = ({ userId }) => {
  const { t } = useTranslation();
  return (
    <GlassCard
      icon={<PiCurrencyDollarLight />}
      title={t('Billing rates')}
      subtitle={t('The default hourly rates this person is billed at.')}
    >
      <UserBillingRatePanel userId={userId} canEdit />
    </GlassCard>
  );
};

export default UserRatesPanel;
